import { Component, OnInit, TemplateRef } from '@angular/core';
import { RestaurantServiceService } from '../../restaurant/restaurant-service.service';
import {Sort} from '@angular/material/sort';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-restaurant-type',
  templateUrl: './restaurant-type.component.html',
  styleUrls: ['./restaurant-type.component.scss']
})
export class RestaurantTypeComponent implements OnInit {
  listOfRestaurantsType: any = [];
  spin = false;
  modalRef: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private router: Router,
    private restaurantServices: RestaurantServiceService
  ) {
    this.getAllRestaurnatType();

   }

  ngOnInit() {
  }
  getAllRestaurnatType() {
    this.restaurantServices.getAllRestaurantsType().subscribe(Response => {
      this.listOfRestaurantsType = Response;
      if (this.listOfRestaurantsType == null) {
        this.spin = true;
      }
      //  this.sortedData = this.countriesList.slice();

    });
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  }

  confirm(id): void {
    this.restaurantServices.DeleteResturantType(id).subscribe(Response => {
      this.getAllRestaurnatType();
    });
    this.modalRef.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }
  AddTypeNavigation() {
    this.router.navigateByUrl('/addRestaurantType');
  }
  UpdateType(id) {
    this.router.navigateByUrl('/updateRestaurantType/' + id);

  }

}
